module.exports = __webpack_public_path__ + "img/skating005.ff34b426.jpg";